import { Menu } from "antd";
// import logo from "../../assets/images/logo.png";
import {
  DashboardOutlined,
  AntDesignOutlined,
  LinkOutlined,
  AlignLeftOutlined,
  TeamOutlined,
  FundOutlined,
  CarryOutOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router";

function Sidenav({ collapsed, isPartner }) {
  const [hideTitle, setHideTitle] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (collapsed) {
      setHideTitle(collapsed);
    } else {
      setTimeout(() => {
        setHideTitle(collapsed);
      }, 400);
    }
  }, [collapsed]);

  return (
    <>
      <div className="brand">
        <FundOutlined className="icon" />
        <span
          className="title"
          style={{
            display: hideTitle ? "none" : "inline",
          }}
        >
          Referral Portal
        </span>
      </div>
      <hr />
      <Menu theme="dark" mode="inline" selectedKeys={pathname.split("/")[2]}>
        <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
          <NavLink to="/admin/dashboard">Dashboard</NavLink>
        </Menu.Item>
        {isPartner ? (
          <Menu.Item key="my-account" icon={<AntDesignOutlined />}>
            <NavLink to="/partner/my-account">My Account</NavLink>
          </Menu.Item>
        ) : (
          <>
            <Menu.Item key="commission-program" icon={<AntDesignOutlined />}>
              <NavLink to="/admin/commission-program">
                Commission Program
              </NavLink>
            </Menu.Item>
            <Menu.Item key="tracking-links" icon={<LinkOutlined />}>
              <NavLink to="/admin/tracking-links">Tracking Links</NavLink>
            </Menu.Item>
            <Menu.Item key="partner-tracking" icon={<AlignLeftOutlined />}>
              <NavLink to="/admin/partner-tracking">Partner Tracking</NavLink>
            </Menu.Item>
            <Menu.Item key="referral-partners" icon={<TeamOutlined />}>
              <NavLink to="/admin/referral-partners">Referral Partners</NavLink>
            </Menu.Item>
            <Menu.Item key="partner-approval" icon={<CarryOutOutlined />}>
              <NavLink to="/admin/partner-approval"> Partner Approval</NavLink>
            </Menu.Item>
          </>
        )}
      </Menu>
    </>
  );
}

export default Sidenav;
